import { render } from "./FlexibleStakingBody.vue?vue&type=template&id=41326795&scoped=true"
import script from "./FlexibleStakingBody.vue?vue&type=script&lang=js"
export * from "./FlexibleStakingBody.vue?vue&type=script&lang=js"

import "./FlexibleStakingBody.vue?vue&type=style&index=0&id=41326795&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41326795"]])

export default __exports__